import { Button, Container, Grid, GridItem, Heading, Link, Text } from "@chakra-ui/react"
import { createFileRoute } from "@tanstack/react-router"
import DocPreviewComponent from "../../components/Common/DocumentPreview"
import { useQuery } from "@tanstack/react-query"
import { getRatecharts } from "../../api/ratecharts"
import NotFound from "../../components/Common/NotFound"

export const Route = createFileRoute("/_layout/inserate")({
  component: Advert,
  notFoundComponent: NotFound,
})

function Advert() {
    const currentYear = new Date().getFullYear()

    const {data: ratecharts} = useQuery({
        ...getRatecharts()
    })

    return (
        <Container>
            <Heading size="4xl" color="main" mb={8}>Inserate</Heading>

            <Text mb={8}>Um Ihre Insertionsaufgabe oder -Anfrage speditiv verarbeiten zu können, senden Sie uns am besten eine E-Mail 
                (<Link href="mailto:info@wochen-zeitung.ch" color="main">info@wochen-zeitung.ch</Link>). 
                <br></br>
                Achten Sie darauf, dass Sie die Erscheinungswoche(n), die Grösse (siehe Tabelle mit Tarif) und die Rechnungsadresse nicht vergessen. 
                Bitte geben Sie uns Ihre Telefonnummer an, damit wir Sie bei Fragen erreichen können.
            </Text>

            <Text mb={8}>
                Weitere Infos zu Prospektbeilagen und weiteren Werbemöglichkeiten finden sie im Booklet.
            </Text>

            <Text mb={8}>Hinweis: Der Maileingang wird nicht automatisch bestätigt - wünschen Sie eine kurze Empfangsbestätigung, 
                erwähnen Sie dies bitte in Ihrer E-Mail - vielen Dank für das Verständnis.
            </Text>

            <Text mb={8}>Gerne stehen wir Ihnen auch telefonisch unter <Link href="tel:+41 34 409 40 01 " color="main">034 409 40 01 </Link> zur Verfügung.</Text>

            <Button variant="primary" asChild mb={10}>
                <Link href="/kontakt">Kontakt</Link>
            </Button>

            <Heading size="xl" color="main">Infos & Tarife {currentYear}</Heading>

            <Grid 
                gap="5"
                templateColumns={{
                    base: "repeat(1, 1fr)",
                    lg: "repeat(2, 0fr)",
                    xl: "repeat(3, 0fr)",
                    "2xl": "repeat(4, 0fr)",
                }}
                justifyItems="center"
            >
                {ratecharts?.data.map((rate) => (
                    <GridItem>
                        <DocPreviewComponent rate={rate} />
                    </GridItem>
                ))}
            </Grid>
        </Container>
    )
}
